import { createContext } from 'react';

const useEventCalendarContext = createContext();
export default useEventCalendarContext;
